import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip, Legend } from 'recharts'
import { FaGlobeAmericas } from 'react-icons/fa'

const NationalityChart = () => {
    const apiUrl = process.env.REACT_APP_API_URL
    const [profiles, setProfiles] = useState([])
    const [errorMessage, setErrorMessage] = useState('')
    const [loading, setLoading] = useState(true)
    
    useEffect(() => {
        axios.get(`${apiUrl}/employee`, {
            headers: {
              loginToken: localStorage.getItem("loginToken")
            }
        })
        .then(res => {
            if(res.data.error){
                setErrorMessage(res.data.error)
            }else{
                setProfiles(res.data)
            }
            setLoading(false)
        })
        .catch(err => {
            setLoading(false)
        })
    }, [])

    const result = Object.values(
        profiles.reduce((acc, { nationality }) => {
            if (!acc[nationality]) {
                acc[nationality] = { name: nationality, value: 0 };
            }
            acc[nationality].value += 1;
            return acc;
        }, {})
    );

    const colors = ['#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6', '#ec4899', '#14b8a6', '#f97316', '#06b6d4', '#8b7355'];

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const data = payload[0].payload;
            const total = result.reduce((sum, item) => sum + item.value, 0);
            const percentage = ((data.value / total) * 100).toFixed(1);
            return (
                <div className="bg-white p-3 rounded-lg shadow-lg border border-gray-200">
                    <p className="text-gray-700 font-semibold">{data.name}</p>
                    <p className="text-purple-600 font-bold">Count: {data.value}</p>
                    <p className="text-gray-600 text-sm">Percentage: {percentage}%</p>
                </div>
            );
        }
        return null;
    };

    if (loading) {
        return <div className="flex items-center justify-center h-80"><p className="text-gray-500">Loading...</p></div>;
    }

    return (
        <div className="w-full flex flex-col gap-2 pt-2 mb-0">
            <div className="flex items-center gap-2">
                <FaGlobeAmericas className="text-purple-600 text-xl" />
                <h2 className="text-xl font-bold text-gray-800">Employee Nationality Distribution</h2>
            </div>
            <p className="text-gray-500 text-sm mb-1">Breakdown of employees by nationality</p>
            <ResponsiveContainer width="100%" height={280}>
                <PieChart>
                    <Pie
                        data={result}
                        dataKey="value"
                        cx="50%"
                        cy="50%"
                        innerRadius={70}
                        outerRadius={110}
                        fill="#8884d8"
                        label={{ position: 'outside', fontSize: 11, fill: '#6b7280', fontWeight: 'bold' }}
                        labelLine={{ stroke: '#d1d5db', strokeDasharray: '3 3' }}
                    >
                        {result.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
                        ))}
                    </Pie>
                    <Tooltip content={<CustomTooltip />} />
                    <Legend 
                        layout="vertical" 
                        align="right" 
                        verticalAlign="middle"
                        formatter={(value, entry) => `${entry.payload.name}: ${entry.payload.value}`}
                    />
                </PieChart>
            </ResponsiveContainer>
        </div>
    )
}

export default NationalityChart
